import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import { DuotoneIcon } from '@atoms/icons';
import { Box, Flex } from '@atoms/layout';
import { MenuItem, Sidebar } from '@organisms/navigation/sidebar';
import { Header } from '@organisms/navigation/header';
import { drawerWidth, headerHeight } from '../../theme';

export function MainLayout({ children }: PropsWithChildren) {
  const theme = useTheme();
  return (
    <Flex bgcolor={theme.palette.applicationBackground}>
      <Header
        position="fixed"
        sx={{
          width: `calc(100% - ${drawerWidth}px)`,
          ml: `${drawerWidth}px`,
        }}
      />

      <Box component="nav" sx={{ width: drawerWidth, flexShrink: { sm: 0 } }} aria-label="mailbox folders">
        <Sidebar topItems={sidebarTopItems} bottomItems={sidebarBottomItems} />
      </Box>

      <Flex
        column
        component="main"
        sx={{
          flexGrow: 1,
          py: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          overflow: 'auto',
        }}
        height="100vh"
      >
        <Toolbar />
        <Container
          maxWidth={false}
          sx={{
            height: `calc(100% - ${headerHeight}px)`,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {children}
        </Container>
      </Flex>
    </Flex>
  );
}

const sidebarTopItems: MenuItem[] = [
  {
    label: <FormattedMessage id="sidebar.dashboard" />,
    icon: ({ active }) => <DuotoneIcon name="grid-2" active={active} />,
    id: 'dashboard',
    path: 'dashboard',
  },
  {
    label: <FormattedMessage id="sidebar.clients" />,
    icon: ({ active }) => <DuotoneIcon name="address-card" active={active} />,
    id: 'clients',
    path: 'clients',
  },
  {
    label: <FormattedMessage id="sidebar.reports" />,
    icon: ({ active }) => <DuotoneIcon name="chart-pie" active={active} />,
    id: 'reports',
    path: 'reports',
  },
];
const sidebarBottomItems: MenuItem[] = [
  {
    label: <FormattedMessage id="sidebar.settings" />,
    icon: ({ active }) => <DuotoneIcon name="gear" active={active} />,
    id: 'settings',
    path: 'settings',
  },
];
